import { render } from "./touchspinDropdown.vue?vue&type=template&id=3b224de6"
import script from "./touchspinDropdown.vue?vue&type=script&lang=js"
export * from "./touchspinDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__